<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar Menu -->
      <ul class="sidebar-menu">
        <li class="header"><strong>Menu</strong></li>
        <router-link
          :to="{ name: 'EditPark', params: { id: this.getParkId() } }"
          tag="li" exact>
          <a><i class="fa fa-user"></i>
            <span>Meu Cadastro</span>
          </a>
        </router-link>

        <router-link
          :to="{ name: 'CompaniesHome', params: { parkId: this.getParkId() } }"
          tag="li" exact>
          <a>
            <i class="fa fa-send"></i>
            <span>Empresas</span>
          </a>
        </router-link>

        <router-link
          :to="{ name: 'GeneralInformations', params: { parkId: this.getParkId() } }"
          tag="li" exact>
          <a>
            <i class="fa fa-info"></i>
            <span>Informações Gerais</span>
          </a>
        </router-link>

        <router-link
          v-if="this.showAnswerMenu"
          :to="{ name: 'ParkQuiz', params: { 'parkId': this.getParkId(), 'referenceYear': this.getReferenceYear(), 'quizUuid': this.parkQuizUuid } }"
          tag="li" exact>
          <a>
            <i class="fa fa-question"></i>
            <span>Responder</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'QuizReports' }" tag="li">
          <a>
            <i class="fa fa-pie-chart"></i>
            Relatórios
          </a>
        </router-link>
      </ul>
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>

import Authentication from '@/services/authentication'
import QuizPeriodClient from '@/services/resource_client/quiz_period'
import ParkQuizClient from '@/services/resource_client/park_quiz'

export default {
  name: 'ParkSidebar',
  data () {
    return {
      showAnswerMenu: false,
      parkQuizUuid: {}
    }
  },
  mounted () {
    this.isAnswerMenuVisible().then(r => { this.showAnswerMenu = r })
  },
  methods: {
    getParkId () {
      return Authentication.getParkId()
    },
    isAnswerMenuVisible () {
      return new Promise((resolve, reject) => {
        this.isParkQuizAvailable()
          .then(r => { resolve(this.isAtOperationStage() && r) })
          .catch(reject)
      })
    },
    isAtOperationStage () {
      return Authentication.getParkCurrentStage() === 'Operação'
    },
    isParkQuizAvailable () {
      return this.getQuizPeriod().then(quizPeriod => {
        let today = (new Date()).toISOString().substring(0, 10)
        if (!quizPeriod || quizPeriod.startingDate > today) {
          return false
        }

        return this.getParkQuiz().then(parkQuiz => {
          if (!parkQuiz && quizPeriod.endingDate < today) {
            return false
          }
          if (parkQuiz && !parkQuiz.isAvailableForAnswering) {
            return false
          }
          this.parkQuizUuid = parkQuiz ? parkQuiz.uuid : null
          return true
        })
      })
    },
    getQuizPeriod () {
      let currentYear = (new Date()).getFullYear()
      return QuizPeriodClient.getByYear(currentYear).then(r => {
        if (r.data.total === 0) {
          return null
        }
        return r.data[0]
      })
    },
    getParkQuiz () {
      let referenceYear = this.getReferenceYear()
      let parkId = Authentication.getParkId()
      return ParkQuizClient.getByYear(parkId, referenceYear).then(r => {
        if (r.data.total === 0) {
          return null
        }
        return r.data[0]
      })
    },
    getReferenceYear () {
      return (new Date()).getFullYear() - 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// ParkSidebar.vue?9673dd44